import { useGlobalStore } from "@/mono/store/global";
import { getGPUTier } from "detect-gpu";
import { useEffect, useState } from "react";

export const minimumFPS = 120;

export default function useDetectCapabilites() {
  //   return navigator.hardwareConcurrency > 1;

  useEffect(() => {
    let supportOffScreenWebGL = false;

    getGPUTier().then((gpuTier) => {
      // TODO: Detect support if we ever do offscreen canvas

      // if (canvasRef.current !== null) {
      //   const isSafari = /^((?!chrome|android).)*safari/i.test(
      //     navigator.userAgent
      //   );
      //   // supportOffScreenWebGL =
      //   //   "transferControlToOffscreen" in canvasRef.current;

      //   // If it's Safari, then check the version because Safari < 17 doesn't support OffscreenCanvas with a WebGL context.
      //   if (isSafari) {
      //     const versionMatch = navigator.userAgent.match(/version\/(\d+)/i);
      //     const safariVersion = versionMatch ? parseInt(versionMatch[1]) : 0;
      //     supportOffScreenWebGL = safariVersion >= 17;
      //   }

      //   // Override setting
      //   if (location.hash.search("regular") > -1) supportOffScreenWebGL = false;
      // }

      let quality = "low";
      if (gpuTier.tier === 3) quality = "high";
      else if (gpuTier.tier === 2) quality = "medium";
      else quality = "low";

      useGlobalStore.setState({
        supportOffScreenCanvas: supportOffScreenWebGL,
        gpuDetect: gpuTier,
        fps: Math.min(gpuTier.fps, minimumFPS),
        quality,
        isReady: true,
      });
    });
  }, []);
}

export function useDetectViewTransitionAPI() {
  const [isViewTransitionAPI, setIsViewTransitionAPI] = useState(false);

  useEffect(() => {
    if ("startViewTransition" in document) setIsViewTransitionAPI(true);
  }, []);

  return isViewTransitionAPI;
}
